import { Component, Input } from '@angular/core';
import { NearbySiteModel } from 'src/app/models/SiteDetails/NearbySiteModel';

@Component({
    selector: 'app-nearby-sites',
    templateUrl: './nearby-sites.component.html',
    styleUrls: ['./nearby-sites.component.scss'],
})

export class NearbySitesComponent {
	
	@Input() nearbySitesModel : NearbySiteModel[];

}
